import { render, staticRenderFns } from "./ModaleDurata.vue?vue&type=template&id=af37fae0&scoped=true&"
import script from "./ModaleDurata.vue?vue&type=script&lang=js&"
export * from "./ModaleDurata.vue?vue&type=script&lang=js&"
import style0 from "./ModaleDurata.vue?vue&type=style&index=0&id=af37fae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af37fae0",
  null
  
)

export default component.exports